/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_DescriptionInputs */

const en_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you're looking for doesn't exist or has been moved.`)
};

const es_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La página que buscas no existe o ha sido movida.`)
};

const fr_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La page que vous recherchez n'existe pas ou a été déplacée.`)
};

const de_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesuchte Seite existiert nicht oder wurde verschoben.`)
};

const ja_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お探しのページは存在しないか、移動した可能性があります。`)
};

const zh_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您正在寻找的页面不存在或已被移动。`)
};

const ar_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة التي تبحث عنها غير موجودة أو تم نقلها.`)
};

const id_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman yang Anda cari tidak ada atau telah dipindahkan.`)
};

const it_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pagina che stai cercando non esiste o è stata spostata.`)
};

const ru_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница, которую вы ищете, не существует или была перемещена.`)
};

const pt_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A página que você está procurando não existe ou foi movida.`)
};

const ko_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`찾으시는 페이지가 존재하지 않거나 이동되었습니다.`)
};

/**
* | output |
* | --- |
* | "The page you're looking for doesn't exist or has been moved." |
*
* @param {Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const not_found_description = /** @type {((inputs?: Not_Found_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_found_description(inputs)
	if (locale === "es") return es_not_found_description(inputs)
	if (locale === "fr") return fr_not_found_description(inputs)
	if (locale === "de") return de_not_found_description(inputs)
	if (locale === "ja") return ja_not_found_description(inputs)
	if (locale === "zh") return zh_not_found_description(inputs)
	if (locale === "ar") return ar_not_found_description(inputs)
	if (locale === "id") return id_not_found_description(inputs)
	if (locale === "it") return it_not_found_description(inputs)
	if (locale === "ru") return ru_not_found_description(inputs)
	if (locale === "pt") return pt_not_found_description(inputs)
	return ko_not_found_description(inputs)
});